define(function(require, exports, module) {
    'use strict';

    const i18n = require('i18n');
    const validationHelpers = require('modules/user/user.validation.helpers');

    const datePickerPrepareData = ($inputs) => {
        const dateParts = $inputs
            .map((input) => input.name.replace(/_.+/g, ''))
            .reduce((result, name, index) => ({
                ...result,
                [name]: parseInt($inputs[index].value)
            }), {});

        const areAllInputsEmpty = Object.values(dateParts).every((datePart) => isNaN(datePart));

        const areAllInputsFilled = Object.values(dateParts).every((datePart) => !isNaN(datePart));

        return {
            date: dateParts,
            areAllInputsEmpty: areAllInputsEmpty,
            areAllInputsFilled: areAllInputsFilled
        };
    };

    const adultDateCheck = (data) => {
        const minAge = 21;
        const adultDate = new Date(data.date.year + minAge, data.date.month - 1, data.date.day);

        return adultDate <= new Date();
    };

    const dateOfBirthValidateFn = ($inputs) => {
        const data = datePickerPrepareData($inputs);

        if (!data.areAllInputsFilled) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.required');

            return false;
        }

        return adultDateCheck(data);
    };

    module.exports = {
        ...validationHelpers,

        dateOfBirthValidateFn
    };
});
